import { ProductPositionsAPIType } from "shared/types/Project"

import { createSerializer } from "../createSerializer"
import { mapTypenameToAPIType } from "../mapTypenameToAPIType"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function productPositionSerializer(data: any, headers: Headers) {
  if (Array.isArray(data)) {
    return createSerializer(ProductPositionsAPIType)(
      data.map(mapParentType),
      headers
    )
  }

  return createSerializer(ProductPositionsAPIType)(mapParentType(data), headers)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapParentType(data: any) {
  return {
    ...data,
    parent: data.parent
      ? {
          id: data.parent.id,
          type: mapTypenameToAPIType(data.parent.type)
        }
      : undefined
  }
}
